import Group from './Group'

export default class CurrentGroup extends Group {
  resource() {
    return 'current-group'
  }
}
